SCM = SCM || {};

SCM.AuthorLinks = (function ($) {
    var _$lastFocused = null;
    var _tabStopSelector = 'a[href], button:not([disabled]), input:not([type="hidden"]):not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

    return {
        init: init,
        showAuthorInfo: showAuthorInfo
    };

    function init() {
        showAuthorInfo($('.js-linked-name'));
        hideAuthorInfo();
        bindCloseButton();
        bindEscape();
        bindFocusOut();
        bindTabOutToTriggerSiblings();
        bindSpaceActivation();
    }

    function showAuthorInfo($authorLinks) {
        $authorLinks.on('click', function (e) {
            var $trigger = $(this);
            var $targetModal = $trigger.siblings('.al-author-info-wrap');
            e.stopPropagation();

            $('.al-author-info-wrap.open').not($targetModal).removeClass('open')
                .siblings('.js-linked-name').attr('aria-expanded', 'false');

            var willBeOpen = !$targetModal.hasClass('open');
            $targetModal.toggleClass('open');
            $trigger.attr('aria-expanded', willBeOpen ? 'true' : 'false');

            if (willBeOpen) {
                _$lastFocused = $trigger;
                $('body').addClass('leftRailModalOpen');
                $targetModal.find('.js-author-info-close').focus();
            } else {
                _$lastFocused = null;
                $('body').removeClass('leftRailModalOpen');
            }
        });
    }

    function hideAuthorInfo() {
        $(document.body).on('click', function (e) {
            var $target = $(e.target);
            if (!$target.parents('.al-author-info-wrap').length && !$target.is('.js-linked-name')) {
                _closeAllPanels();
            }
        });
    }

    function bindCloseButton() {
        $(document).on('click', '.js-author-info-close', function () {
            _closeAllPanels();
            var $panel = $(this).closest('.al-author-info-wrap');
            var $trigger = $panel.siblings('.js-linked-name');
            $trigger.focus();
            _$lastFocused = null;
        });
    }

    function bindEscape() {
        $(document).on('keydown', function (e) {
            if (e.key !== 'Escape' && e.keyCode !== 27) {
                return;
            }
            if (!$('.al-author-info-wrap.open').length) {
                return;
            }
            _closeAllPanels();
            if (_$lastFocused && _$lastFocused.length) {
                _$lastFocused.focus();
                _$lastFocused = null;
            }
        });
    }

    function bindFocusOut() {
        // WCAG 1.4.13 (Dismissible): when keyboard focus leaves the card and its
        // trigger entirely (e.g., tabbing past the last link in the card, or
        // shift-tabbing back before the trigger), close the card so it no longer
        // overlaps adjacent content. Unlike Escape, focus is already moving on to
        // its natural next target, so we do not restore focus here.
        $(document).on('focusout', '.js-linked-name, .al-author-info-wrap', function (e) {
            var $openCard = $('.al-author-info-wrap.open');
            if (!$openCard.length) {
                return;
            }
            var next = e.relatedTarget;
            if (!next) {
                // Focus left the document (e.g., browser chrome/dev tools); leave
                // the card alone. Clicks outside are handled by hideAuthorInfo().
                return;
            }
            var $next = $(next);
            var $openTrigger = $openCard.siblings('.js-linked-name');
            var staysInComponent = $next.is($openTrigger) ||
                $next.closest('.al-author-info-wrap')[0] === $openCard[0];
            if (staysInComponent) {
                return;
            }
            _closeAllPanels();
            _$lastFocused = null;
        });
    }

    // A native Tab out of the card skips the trigger's siblings that sit before it, such as an author-note symbol (ACS-1641).
    function bindTabOutToTriggerSiblings() {
        $(document).on('keydown', '.al-author-info-wrap.open', function (e) {
            var $card = $(this);
            var $cardStops;
            var $trigger;
            var $skippedStops;
            if (e.key !== 'Tab' || e.shiftKey) {
                return;
            }
            $cardStops = $card.find(_tabStopSelector).filter(':visible');
            $trigger = $card.siblings('.js-linked-name');
            if (!$cardStops.length || e.target !== $cardStops.last()[0] || !$trigger.nextAll().is($card)) {
                return;
            }
            $skippedStops = $trigger.nextUntil($card).find(_tabStopSelector).addBack(_tabStopSelector).filter(':visible');
            if (!$skippedStops.length) {
                return;
            }
            e.preventDefault();
            _closeAllPanels();
            _$lastFocused = null;
            $skippedStops.first().focus();
        });
    }

    function bindSpaceActivation() {
        // The author trigger is an <a> whose role is button (link-as-button pattern).
        // Anchors fire click on Enter natively; Space scrolls the page. role=button
        // requires Space to also activate, so forward Space to a synthetic click.
        $(document).on('keydown', '.js-linked-name', function (e) {
            if (e.key !== ' ' && e.keyCode !== 32) {
                return;
            }
            e.preventDefault();
            $(this).trigger('click');
        });
    }

    function _closeAllPanels() {
        $('.al-author-info-wrap.open').removeClass('open');
        $('.js-linked-name[aria-expanded="true"]').attr('aria-expanded', 'false');
        $('body').removeClass('leftRailModalOpen');
    }
})(jQuery);
